import { render, staticRenderFns } from "./AdminConfigurations.vue?vue&type=template&id=12ea5af5&"
import script from "./AdminConfigurations.vue?vue&type=script&lang=js&"
export * from "./AdminConfigurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports